import actions from './actions';

export default {
  namespaced: false,
  actions,
};
